import { sortBy } from 'lodash';

import {
  sankeyFormFlowsArrayToMap,
  sankeyFormFlowsMapToArray,
} from 'utils/sankey';

import { useSankeyFormContext } from '../../../../contexts/sankeyFormContext';
import { newFlowId } from '../../../../diagram/flows';
import { TeamSettings } from '../../../../utils/team';
import { getNodeNamesFromFlows } from '../../../DataEditor/utils';
import { updateNodesFromFlows } from '../../utils';

// Returns a list of all node names from the given flows, sorted alphabetically
export const useAllNodeNames = () => {
  const { form } = useSankeyFormContext();
  const flows = sankeyFormFlowsMapToArray(form.watch('flows'));
  return sortBy(getNodeNamesFromFlows(flows));
};

// TODO: Unit test this method
export const updateFlowNode = (
  form: SankeyForm,
  flowId: string,
  field: 'source' | 'target',
  newNodeName: string,
  teamSettings: TeamSettings
) => {
  form.setValue(
    'flows',
    {
      ...form.getValues('flows'),
      [flowId]: {
        ...form.getValues(`flows.${flowId}`),
        [field]: newNodeName,
      },
    },
    { shouldDirty: true }
  );
  updateNodesFromFlows(form, teamSettings);
};

// Remove the flow with the given ID and re-index the rest of them
// TODO: Unit test this method
export const removeFlow = (
  form: SankeyForm,
  flowId: string,
  teamSettings: TeamSettings
) => {
  form.setValue(
    'flows',
    sankeyFormFlowsArrayToMap(
      sankeyFormFlowsMapToArray(form.getValues('flows'))
        .filter((flow) => flow.id !== flowId)
        .map((flow, dataGridRowIndex) => ({
          ...flow,
          id: newFlowId(dataGridRowIndex),
          dataGridRowIndex,
        }))
    ),
    { shouldDirty: true }
  );
  updateNodesFromFlows(form, teamSettings);
};
